import React from 'react';
import styles from './FaqAnswerContent.module.scss';
import { FaqAnswer } from '../../../../Models';
import { FaqAnswerImg } from './FaqAnswerImg/FaqAnswerImg';
import { HtmlContent } from '../../../../Components/HtmlContent/HtmlContent';

export interface FaqAnswerContentProps {
  answer: FaqAnswer;
}

export const FaqAnswerContent = ({
  answer
}: FaqAnswerContentProps): React.ReactElement<FaqAnswerContentProps> => {
  return (
    <div className={styles.faqAnswer}>
      <HtmlContent content={answer.content || ''} />

      {answer.image_desktop && answer.image_mobile && (
        <FaqAnswerImg
          srcDesktop={answer.image_desktop}
          srcMobile={answer.image_mobile}
        />
      )}
    </div>
  );
};
